import {useDroppable} from '@dnd-kit/core';
import type {CSSProperties} from 'react';

import type {UseRowProps} from '../types';

import useTimelineContext from './useTimelineContext';
// CodeReviewAhmedLater: add return type to this
// Have changed this to later since dnd-kit does not export its typings yet
export default function useRow(props: UseRowProps) {
  const {setSidebarRef} = useTimelineContext();

  const droppableProps = useDroppable({
    id: props.id,
    data: props.data,
    disabled: props.disabled,
  });

  const rowWrapperStyle: CSSProperties = {
    display: 'inline-flex',
  };

  const rowStyle: CSSProperties = {
    flex: 1,
    display: 'flex',
    position: 'relative',
    alignItems: 'stretch',
    flexDirection: 'column',
  };

  const rowSidebarStyle: CSSProperties = {
    left: 0,
    zIndex: 3,
    display: 'flex',
  };

  // CodeReviewAhmedLater: properly define the return type of this hook and any other hooks that you've added in this branch
  // Have changed this to later since dnd-kit does not export its typings yet
  return {
    rowStyle,
    rowWrapperStyle,
    rowSidebarStyle,
    setSidebarRef,
    ...droppableProps,
  };
}
